// Push Notifications opt-in helper
// Note: Without VAPID server-push keys, this enables LOCAL browser notifications only
// (used for booking-status alerts triggered from in-app polling).
export async function requestNotificationPermission() {
  if (!("Notification" in window)) return "unsupported";
  if (Notification.permission === "granted") return "granted";
  if (Notification.permission === "denied") return "denied";
  try {
    const p = await Notification.requestPermission();
    return p;
  } catch {
    return "error";
  }
}

export function showNotification(title, options = {}) {
  if (!("Notification" in window) || Notification.permission !== "granted") return false;
  try {
    const n = new Notification(title, {
      icon: "/logo192.png",
      badge: "/logo192.png",
      ...options,
    });
    setTimeout(() => { try { n.close(); } catch { /* ignore */ } }, 8000);
    return true;
  } catch {
    return false;
  }
}
